<template>
  <div class="tab-content-container">
    <div class="tab-header-container">
      <h2 class="form-label">Екипи, за които потребителя има права</h2>
      <LiteButton @click.native="shouldEditButtonClicked"
                  class="edit-button"
                  v-show="!shouldEditTeams"
                  :hoverColor="'blue'"
                  :icon="'far fa-edit'">
      </LiteButton>
      <LiteButton @click.native="shouldEditButtonClicked"
                  style="font-size: 27px;"
                  class="edit-button"
                  v-show="shouldEditTeams"
                  :hoverColor="'red'"
                  :icon="'far fa-window-close'">
      </LiteButton>
    </div>

    <hr class="form-line">
      <div class="profession-counters-container">
        <h2 class="team-edit-subtitle" style="float: left; color: var(--primary-blue);">Екипи към потребителя</h2>
        <h2 class="team-edit-subtitle" v-if="shouldEditTeams" style="float: right; color: var(--primary-green);">Добавяне на екип</h2>
      </div>

      <Grid class="grid"
            :config="removeConfig"
            :gridData="userTeamList"
            :loading="isUserTeamsListLoading"
            style="float: left;"
            :style="{width: shouldEditTeams ? '49.5%' : 'fit-content'}"
            @row-clicked="removeRowClicked">
      </Grid>

      <Grid class="grid"
            v-if="shouldEditTeams"
            :config="addConfig"
            :gridData="teamsNotAssignedToUser"
            :loading="isUserTeamsNotAssignedLoading"
            style="float: right;"
            @row-clicked="addRowClicked">
      </Grid>

      <Button class="save-edit-team-members-button"
              v-if="shouldEditTeams"
              @click.native="saveTeamPermissions"
              :color="'green'"
              :text="'Запази'"
              :icon="'fa fa-save'"/>
  </div>
</template>

<script>
import Grid from "@/shared/components/grid/Grid";
import teamListGridConfig from "@/components/team/team-list-grid.config";
import {cloneDeep} from 'lodash';
import Button from "@/shared/components/button/Button";
import authorizationService from "@/services/authorization.service";
import teamService from "@/services/team.service";
import LiteButton from "@/shared/components/button/LiteButton";

export default {
  name: "UserTeamsEditForm",
  components: {LiteButton, Button, Grid},
  created() {
    this.getUserTeams();
    authorizationService.getUserById(this.userId)
        .then(({data}) => this.currentUser = data);
    teamService.fetchTeams()
        .then(({data}) => {
          this.allTeams = data;
          this.isUserTeamsNotAssignedLoading = false;
        });
  },
  data() {
    return {
      userId: this.$route.params.id,
      userTeamList: [],
      currentUser: null,
      isUserTeamsListLoading: true,
      isUserTeamsNotAssignedLoading: true,
      allTeams: [],
      shouldEditTeams: false,
      tableHeight: 325
    }
  },
  methods: {
    getUserTeams() {
      authorizationService.getUserTeams(this.userId)
          .then(({data}) => {
            this.userTeamList = data.teams;
            this.isUserTeamsListLoading = false;
          });
    },
    shouldEditButtonClicked() {
      this.shouldEditTeams = !this.shouldEditTeams;
      this.getUserTeams();
    },
    addRowClicked(row) {
      this.userTeamList.push(row);
    },
    removeRowClicked(row) {
      this.userTeamList = this.userTeamList.filter((team) => team.id !== row.id);
    },
    saveTeamPermissions() {
      authorizationService.updateUserTeams(this.userId, this.userTeamList)
          .then(() => {
            this.shouldEditTeams = false;
            this.getUserTeams();
          });
    }
  },
  computed: {
    addConfig() {
      const temp = cloneDeep(teamListGridConfig);
      temp.props.tableHeight = this.tableHeight;
      temp.columns = temp.columns.filter((column) => column.selector !== 'professionName');
      temp.props.selectableColumn.icon = 'fa fa-plus';
      return temp;
    },
    removeConfig() {
      const temp = cloneDeep(teamListGridConfig);
      temp.props.tableHeight = this.tableHeight;
      temp.props.selectableColumn.icon = 'fa fa-minus';
      if (!this.shouldEditTeams) {
        temp.props.selectableColumn.show = false;
      }
      return temp;
    },
    teamsNotAssignedToUser() {
      const teamIds = this.userTeamList.map((team) => team.id);
      return this.allTeams
          .filter((team) => !teamIds.includes(team.id));
    },
    getUserName() {
      const firstName = this.currentUser && this.currentUser.firstName ? this.currentUser.firstName : '';
      const lastName = this.currentUser && this.currentUser.lastName ? this.currentUser.lastName : '';
      return firstName + ' ' + lastName;
    }
  }
}
</script>

<style scoped>
@import '../../../css/shared/tabs.css';

.edit-user-teams-container {
  padding: 20px;
  box-sizing: border-box;
}

.grid {
  margin-top: 20px;
  margin-bottom: 50px;
  display: inline-block;
  width: 49.5%;
}

.save-edit-team-members-button {
  width: 400px;
  height: 60px;
  margin: 0 auto;
  display: inline-block;
  font-size: 25px;
}

.profession-counters-container {
  width: 100%;
  display: inline-block;
}

.team-edit-subtitle {
  width: 49.5%;
  margin-top: 10px;
  display: inline-block;
}

</style>
